<template>
    <div class="max-size" :class="{oversize, hidden: currentSize === 0}">
        <span class="remaining">{{$t('used_chars')}}:</span>
        <span class="current">{{currentSize}}</span>
        <span class="slash">/</span>
        <span class="max">{{maxSize}}</span>
    </div>
</template>

<script>
    export default {
      name: "maxSize",

      props: {
        value: String,
        maxSize: Number
      },

      computed: {
        currentSize() {
          return this.value ? (this.value.length || 0) : 0;
        },
        oversize() {
          return this.currentSize > this.maxSize;
        }
      }
    }
</script>

<style lang="scss" scoped>
    .max-size {
        display: flex;
        width: 100%;
        justify-content: flex-end;
        color: #808080;
        font-size: 14px;

        .remaining {
            margin-right: 4px;
        }

        &.oversize {
            .slash, .current, .max {
                color: red;
                font-weight: 600;
            }
        }
    }
</style>